import { toEmoji } from "./specific-operate/emoji";

export default {
  toEmoji
}